import { DtacBase } from "./dtac-base";

export const MASTER_WAYBILL = 'Master';
export const HOUSE_WAYBILL = 'House';

export interface Waybill extends DtacBase {
  waybillNumber: string;
  waybillType: string;
  waybillPrefix: string;
  containedWaybills: Waybill[];
};

export const WAYBILL_TEMPLATE: Waybill = {
  '@id': '',
  '@type': '',
  waybillNumber: '',
  waybillType: '',
  waybillPrefix: '',
  containedWaybills: []
};
